<template>

<div class="list-view no-sidebar">

    <loading v-if="loading"></loading>

	<div v-else-if="!editingDisposal" class="detail no-sub-header ">

		<div class="two-columns align-items-start">

			<div>
				<div class="section">
					<h2>Disposition Info</h2>
					<div class="two-columns">
						<label-required label="Date Disposed" :condition="entry.disposal_date"></label-required>
						<div></div>
						<input type="date" v-model="entry.disposal_date" style="width: 11em;">
						<div v-if="disposeFrom4473" class="notes right"><span class="inline-link" @click="switchDisposalSearch">Dispose from serial number search?</span></div>
						<div v-else class="notes right"><span class="inline-link" @click="switchDisposalSearch">Dispose from an eligible 4473?</span></div>
					</div>
					<template v-if="disposeFrom4473">
						<label-required label="Disposed To" :condition="$fullName(contact)"></label-required>
						<div class="input-with-control">
							<input type="text" v-model="search_4473" placeholder="Search eligible 4473s..." @focus="showLogBookFormList = true">
							<div :class="['button', search_4473 ? 'action' : 'disabled', 'input-go']"><i class="fas fa-search"></i></div>
						</div>
						<div v-if="showLogBookFormList" class="search-result bordered">
							<ul v-if="filteredLogBookForms && filteredLogBookForms.length != 0" class="search-list">
								<li class="clickable-list-item" v-for="(logBookForm, index) in filteredLogBookForms" @click="getDisposeThisForm(logBookForm.ffl_log_book_form_id)">
									<span>{{ logBookForm.version > 1 ? $fullName(logBookForm.form_data.section_b) : $fullName(logBookForm.form_data) }}</span>
									<span>{{ logBookForm.version > 1 ? logBookForm.form_data.section_b.address_1 : logBookForm.form_data.address_1 }}</span>
									<span>{{ logBookForm.nics_number }}</span>
									<span>{{ logBookForm.version > 1 ? logBookForm.form_data.section_b.city : logBookForm.form_data.city }}, {{ logBookForm.version == 2 ? logBookForm.form_data.section_b.state : logBookForm.form_data.state }} {{ logBookForm.version == 2 ? logBookForm.form_data.section_b.zip_code : logBookForm.form_data.zip_code }}</span>
									<span style="color: red;" v-for="firearm in logBookForm.form_data.section_a.firearms_list">{{ firearm.model }}</span>

								</li>
							</ul>
							<ul v-else class="search-list no-results">
								<li>No eligible 4473s found.</li>
							</ul>
						</div>
						<div class="search-result bordered">
							{{ contact.full_name || $fullName(contact) }}<br>
							{{ contact.address_1 }}<br>
							<template v-if="contact.address_2">{{ contact.address_2 }}<br></template>
							{{ entry.city }}<span v-if="entry.city">,</span> {{ entry.state }} {{ contact.zip_code }}<br>
							<template v-if="contact.ffl_number">FFL: {{ contact.ffl_number }}</template>
						</div>
					</template>
					<template v-else>
						<div class="three-one-columns">
							<div>
								<label-required label="Disposed To" :condition="$fullName(contact)"></label-required>
								<div v-if="!showFFLSearch" class="input-with-control">
									<input type="text" v-model="search_disposals" placeholder="Search dispositions..." @keyup.enter="searchDisposals()" v-focus>
									<div :class="['button', search_disposals ? 'action' : 'disabled', 'input-go']" @click="searchDisposals()"><i class="fas fa-search"></i></div>
								</div>
								<ffl-number-search v-if="showFFLSearch" @searchResult="setList" />
							</div>
							<div>
								<button class="neutral smaller full-width" style="margin: 0.66em 0 0.33em 0;" @click="showFFLSearch = !showFFLSearch">Search By {{ showFFLSearch ? 'Name' : 'FFL' }}</button>
								<button class="neutral smaller full-width" @click="newDisposedTo()">Create Disposed To</button>
							</div>
						</div>

						<div class="search-result bordered">
							<loading v-if="searchingDisposals"></loading>
							<ul v-else-if="disposals && disposals.length != 0" class="search-list">
								<li class="clickable-list-item" v-for="(disposal, index) in disposals" @click="assignDisposal(disposal)">
									<span>{{ disposal.full_name || $fullName(disposal) }}</span>
									<span>{{ disposal.address_1 }}</span>
									<span>{{ disposal.ffl_number }}</span>
									<span>{{ disposal.city }}<span v-if="disposal.city">,</span> {{ disposal.state }} {{ disposal.zip_code }}</span>
									<span v-if="disposal.activityDate">
                						<b>Has recent disposal or 4473 activity {{ formatRelativeDate(disposal.activityDate) }} ({{ disposal.activityDate.format("MM-DD-YY") }})</b>
              						</span>
								</li>
							</ul>
							<ul v-else-if="disposalSearchMessage" class="search-list no-results">
								<li>{{ disposalSearchMessage }}</li>
							</ul>
							<template v-else>
								{{ contact.full_name || $fullName(contact) }}<br>
								{{ contact.address_1 }}<br>
								<template v-if="contact.address_2">{{ contact.address_2 }}<br></template>
								{{ contact.city }}<span v-if="contact.city">,</span> {{ contact.state }} {{ contact.zip_code }}<br>
								<template v-if="contact.ffl_number">FFL: {{ contact.ffl_number }}</template>
								<div v-if="contact.client_id == client_id && contact.contact_id != getClient.contact_id" class="controls" style="position: absolute; bottom: -0.75em; right: 3px;">
									<button class="neutral" @click="editingDisposal = true">Edit</button>
								</div>
							</template>
						</div>

					</template>
				</div>

				<div v-if="fflTransactionInfoRequired" class="section">
					<h2>Additional Transaction Info</h2>
					<div class="checkbox-group">
						<span :class="['pointer', 'far', !entry.transaction_info_required ? 'fa-check-square' : 'fa-square']" @click="entry.transaction_info_required = !entry.transaction_info_required"></span>
						<label>Check if additional transaction info is <b>NOT</b> required with this disposition.</label>
					</div>

					<!-- <div v-if="fflTransactionInfoRequired && entry.transaction_info_required" class="three-columns">
						<div>
							<label-required label="Gender" :condition="entry.gender"></label-required>
							<select v-model="entry.gender">
								<option value="">Select...</option>
								<option value="M">M</option>
								<option value="F">F</option>
								<option value="U">X</option>
								<option value="not_disclosed">Prefer not to disclose</option>
							</select>
						</div>
						<div>
							<label-required label="Ethnicity" :condition="entry.ethnicity"></label-required>
							<select v-model="entry.ethnicity">
								<option value="">Select...</option>
								<option value="hispanic">Hispanic or Latino</option>
								<option value="nonhispanic">Not Hispanic or Latino</option>
								<option value="not_disclosed">Prefer not to disclose</option>
							</select>
						</div>
						<div>
							<label-required label="Race" :condition="entry.race"></label-required>
							<select v-model="entry.race">
								<option value="">Select...</option>
								<option value="asian">Asian</option>
								<option value="mixed">Mixed Race</option>
								<option value="black">Black</option>
								<option value="native_american">Native American</option>
								<option value="caucasian">Caucasian</option>
								<option value="native_hawaiian">Native Hawaiian/Pacific Islander</option>
								<option value="unknown">Unknown</option>
								<option value="not_disclosed">Prefer not to disclose</option>
							</select>
						</div>
					</div> -->

					<div v-if="entry.transaction_info_required" class="two-columns">
						<div>
							<label-required label="Date of Birth" :condition="entry.date_of_birth"></label-required>
							<input type="date" v-model="entry.date_of_birth">
						</div>
						<!-- <div>
							<label-required label="Occupation" :condition="entry.occupation"></label-required>
							<input type="text" v-model="entry.occupation">
						</div> -->
					</div>

					<!-- <div v-if="fflTransactionInfoRequired && entry.transaction_info_required" class="section-divider"></div> -->
					<div v-if="fflTransactionInfoRequired && entry.transaction_info_required" class="two-columns">
						<div>
							<label-required label="Dealer Transaction Log Disposition Type" :condition="entry.disposition_type"></label-required>
    						<tool-tip left='-11' content="This disposition type is required for the Firearms Dealer Transaction Log."/>
							<select v-model="entry.disposition_type">
								<option value="">Select...</option>
								<option value="sale">Sale</option>
								<option value="rental">Rental</option>
								<option value="exchange">Exchange</option>
								<option value="transfer">Transfer</option>
							</select>
						</div>
						<div>
							<label-required label="A&D Record Disposition Type" :condition="entry.disposition_type_ad"></label-required>
    						<tool-tip left='-11' content="This disposition type is required for the Firearms Dealer Acquisition and Disposition Record."/>
							<select v-model="entry.disposition_type_ad">
								<option value="">Select...</option>
								<option value="sale">Sale</option>
								<option value="rental">Rental</option>
								<option value="exchange">Exchange</option>
								<option value="transfer">Transfer</option>
							</select>
							<input v-if="entry.disposition_type == 'other'" type="text" v-model="entry.disposition_type_other" placeholder="Enter other description"/>
						</div>
						<div>
							<label-required label="Employee Name" :condition="entry.employee_name"></label-required>
							<input type="text" v-model="entry.employee_name">
						</div>
					</div>
					<div v-if="entry.disposition_type == 'transfer'" class="two-columns">
						<label>Firearm Dealer Permit Number</label>
						<label-required label="FFL Number" :condition="entry.disposition_ffl_number"></label-required>
						<input type="text" v-model="entry.disposition_dealer_permit_number">
						<input type="text" v-model="entry.disposition_ffl_number">
					</div>
				</div>

				<div class="section">
					<h2>Dispose With</h2>
					<div class="three-columns">
						<label>NICS Number or CCW</label>
						<label></label>
						<label>Repair Number</label>
					</div>
					<div class="three-columns">
						<input type="text" v-model="entry.nics_number">
						<div class="checkbox-group">
							<span :class="['pointer', 'far', nics_not_required ? 'fa-check-square' : 'fa-square']" @click="toggleNICSNotRequired()"></span>
							<label>NICS not required</label>
						</div>
						<input type="text" v-model="entry.repair_number">
					</div>
					<label>Note</label>
					<textarea v-model="entry.notes" style="height: 4em;"></textarea>
					<div class="section_dead" v-if="sectionsComplete < 2"></div>
				</div>
			</div>

			<div>
				<div class="section">
					<h2>Serial Numbers</h2>
					<label-required label="Enter one or more serial numbers for this disposition" :condition="serial_numbers.length > 0"></label-required>

					<div style="width: 60%;">
						<div class="input-with-control">
							<input type="search" @search="searchSerialNumbers()" v-model="serialNumberSearch" placeholder="Search serial numbers...">
							<div class="button action input-go" @click="searchSerialNumbers()"><i class="fas fa-search"></i></div>
						</div>
					</div>

					<div class="section-divider"></div>

					<div v-if="serial_numbers.length == 0">
						<div class="message center">No serial numbers selected.</div>
					</div>

					<div v-else class="two-columns" style="grid-gap: 1em;">
						<div v-for="(serial_number, index) in serial_numbers" style="position: relative;">
							<div v-if="serial_number['sequence_number']" style="font-size: 1em; line-height: 1.75em; border: 1px solid #ccc; padding: 0 0.5em;">
								<div><label>Serial Number:</label> <b style="color: red;">{{ serial_number['serial_number'] }}</b></div>
								<div><label>Sequence Number:</label> <b>{{ serial_number['ffl_log_book_code'] + '-' + serial_number['sequence_number'] }}</b></div>
								<div class="one-three-columns">
									<label>Type:</label>{{ serial_number.gun_type }}
									<label>Make:</label>{{ serial_number.manufacturer }}
									<label>Model:</label>{{ serial_number.model }}
									<label>Caliber:</label>{{ serial_number.caliber }}
								</div>
								<div v-if="fflTransactionInfoRequired && entry.transaction_info_required && gunTypesRequired.includes(serial_number['gun_type'])" class="one-three-columns">
									<label-required label="Finish:" :condition="serial_number.finish"></label-required>
									<select v-model="serial_number.finish">
										<option value="">Select...</option>
										<option value="black">Black</option>
										<option value="blue_steel">Blue Steel</option>
										<option value="nickel">Nickel</option>
										<option value="stainless_steel">Stainless Steel</option>
										<option value="two_toned">Two-Toned</option>
										<option value="cerakote">Cerakote</option>
										<option value="other">Other</option>
									</select>
								</div>
								<div v-if="serial_number.finish == 'two_toned'" class="one-three-columns">
									<label></label>
									<div>
										<label-required label="Tone 1" :condition="serial_number.finish_two_toned_1"></label-required>
										<input type="text" v-model="serial_number.finish_two_toned_1">
										<label-required label="Tone 2" :condition="serial_number.finish_two_toned_2"></label-required>
										<input type="text" v-model="serial_number.finish_two_toned_2">
									</div>
								</div>
								<div v-if="serial_number.finish == 'cerakote'" class="one-three-columns">
									<label></label>
									<div>
										<label-required label="Color" :condition="serial_number.finish_cerakote"></label-required>
										<input type="text" v-model="serial_number.finish_cerakote">
									</div>
								</div>
								<div v-if="serial_number.finish == 'other'" class="one-three-columns">
									<label></label>
									<div>
										<label-required label="Other Finish" :condition="serial_number.finish_other"></label-required>
										<input type="text" v-model="serial_number.finish_other" placeholder="Finish">
									</div>
								</div>
							</div>
							<div class="button small neutral" style="position: absolute; top: 0; right: 0;" @click="removeSerialInput(index)">X</div>

						</div>
					</div>
					<div class="section_dead" v-if="sectionsComplete < 1"></div>
					<div class="section-divider"></div>
				</div>

				<div class="section">
					<div style="width: 60%;">
						<div class="input-with-control input-with-control-with-tip">
							<input type="text" v-model="entry.form_number" placeholder="Transaction Serial Number" @keyup.enter="searchFormNumbers()">
							<div class="button input-go action" @click="searchFormNumbers()"><i class="fas fa-search"></i></div>
							<span class="inline-tip fas fa-info-circle" @click="showToolTip = true"></span>
						</div>
						<div v-if="form_numbers.length > 0 || formNumberSearchMessage" class="search-result bordered" style="margin: 0 1em 0 0;">
							<div class="controls"><button class="button action" @click="form_numbers = []">X</button></div>
							<ul v-if="form_numbers.length > 0" class="search-list" style="margin: 0 3em 0 0;">
								<li class="clickable-list-item" v-for="(form_number, index) in form_numbers" @click="assignFormNumber(form_number)">
									{{ form_number }}
								</li>
							</ul>
							<ul v-else class="search-list no-results">
								<li>{{ formNumberSearchMessage }}</li>
							</ul>
						</div>
					</div>


					<div class="section-divider"></div>
					<div :class="['button', 'spaced', isDisposable && !dispositionComplete ? 'action' : 'disabled' ]" @click="saveDisposition()">Save Disposition</div>
					<button class="cancel" @click="clearData(true);">{{ dispositionComplete ? 'Clear' : 'Cancel' }}</button>
					<button v-if="dispositionComplete && entry.ffl_log_book_entry_id" :class="['action', { disabled: loadingLogBookEntry }]" style="margin: 0 0 0 0.5em;" @click="doPrint()">Print Disposition Receipt</button>

					<div class="section_dead" style="height: 3em;" v-if="sectionsComplete < 3"></div>

				</div>
			</div>

		</div>

	</div>

	<div v-else class="detail three-one-columns">
		<div class="detail-form">
			<h2>Disposed To Info</h2>
			<contact-detail-form :clientId="client_id" :contact="contact" @save="assignDisposal($event)" @cancel="editingDisposal = false"></contact-detail-form>
		</div>
		<div class="detail-stats list">
			<h2>Note</h2>
			<div v-if="contact.contact_id">
				<p>Editing this contact record will not affect previously saved log book entries. The contact will be updated for this and future disposition records.</p>
			</div>
			<div v-else>
				<p>You are adding a new contact record that can be used for this and future disposition records.</p>
			</div>
		</div>
	</div>

	<div v-if="serialNumberSearchResults.length > 0 || serialNumberSearchMessage" class="modal">
		<div class="inner">
			<h2>Serial Number Search</h2>
			<div class="content">
				<div v-if="serialNumberSearchResults.length > 0" class="search-result search-list">
					<div class="clickable-list-item two-columns v-spaced" v-for="(entry, index) in serialNumberSearchResults" @click="assignSerialNumber(entry)">
						<div>
							<div>Sequence: <b>{{ entry.ffl_log_book_code }}-{{ entry.sequence_number }}</b></div>
							<div>Serial Number: <b>{{ entry.serial_number }}</b></div>
						</div>
						<div>
							<div>{{ entry.manufacturer }} {{ entry.model }}</div>
							<div>{{ entry.gun_type }} {{ entry.caliber }}</div>
						</div>
					</div>
				</div>
				<ul v-else class="search-list no-results">
					<li>{{ serialNumberSearchMessage }}</li>
				</ul>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelSerialNumberSearchResults()">Cancel</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showModal">
		<div class="inner">
			<h2>{{ $caplitalizeWords(modalFor) }}</h2>
			<div class="content">
				<div v-if="modalStatus == 'error'" class="center" style="font-size: 1.5em; margin: 0.5em; color: gray;"><i class="fa fa-bell"></i></div>
				<div v-html="modalContent" style="margin: 1em;"></div>
				<div v-if="loadingModal" class="center" style="margin: 1em;"><i class="fa fa-spinner fa-spin"></i></div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showModal = false">Got It</div>
				<div class="button action spaced" @click="goToForm()">Go To 4473</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showToolTip">
		<div class="inner">
			<h2>Transaction Serial Number</h2>
			<div class="content">
				<p>You can enter the Transferor's / Seller's Transaction Serial Number from the 4473 associated with this disposal.</p>
				<p>This will help you link this disposal to that specific 4473 in your electronic or paper filing system.</p>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showToolTip = false">Got It</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading || saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{208:'Dispose Electronically', 209:'Dispose Manually', 210:'Correcting Logbook Errors'}" :tours="false"></help-popup>

</div>

</template>

<script>
import FFLNumberSearch from "@/components/FFLNumberSearch.vue"
import LabelRequired from '@/components/LabelRequired.vue'
import ContactDetailForm from '@/components/ContactDetailForm.vue'
import HelpPopup from '@/components/HelpPopup.vue'
import ToolTip from '@/components/ToolTip.vue'

export default {
	name: 'logbooks-dispose',
	props: ['4473','id'],
    components: {
		'ffl-number-search': FFLNumberSearch,
        'label-required': LabelRequired,
        'contact-detail-form': ContactDetailForm,
		'help-popup': HelpPopup,
		'tool-tip': ToolTip
    },
	data() {
		return {
            loading: false,
            saving: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
            searchingDisposals: false,
			client_id: null,
			disposeFrom4473: true,
			showLogBookFormList: false,
			fflTransactionInfoRequired: false,
			employeeDealerNumber: '',
			employeeName: '',
			entry: {},
    		editingDisposal: false,
    		logBookForms: [],
    		logBookFormId: null,
    		serial_numbers: [],
			serialNumberSearch: '',
			search_disposals: null,
			disposalSearchMessage: null,
			search_4473: null,
			disposals: [],
			contact: {
				notes: [{ note: '', priority: '' }]
			},
			ffl_log_book_form_id: '',
			searchingSerialNumberIndex: 0,
			serialNumberSearchResults: [],
			serialNumberSearchMessage: '',
			showModal: false,
    		modalFor: '',
    		modalContent: '',
			loadingModal: false,
			modalStatus: '',
    		showToolTip: false,
			showFFLSearch: false,
    		form_numbers: [],
			formNumberSearchMessage: '',
			nics_not_required: '',
            dispositionComplete: false,
            loadingLogBookEntry: false,
			selectedFormId: '',
            reloadDateInput: Math.random(), // will re-render component on clearData()
			gun_types: [],
			gunTypesRequired: [],
			recentActivities: []
		}
	},
    created() {
		this.getRequiredGunTypes()
		this.apiCall({ destination: 'get_ffl_number_info' }).then(obj => {
			this.fflTransactionInfoRequired = obj.firearms_transaction_info_required
			if (this.fflTransactionInfoRequired) {
				this.employeeDealerNumber = obj.state_permit_number
				this.employeeName = this.$fullName(obj.user_contact)
			}
			if (this.id) {
				this.disposeFrom4473 = false
				this.getListSerialNumbers()
				if (this.$route.query.disposal_contact_id) {
					this.getDisposalById(this.$route.query.disposal_contact_id)
				}
			} else {
				this.getListLogBookForms()
			}
			this.clearData()
			this.resetContact()
		}).catch(err => {
			console.log(err)
		})
    },
    mounted() {
		// console.log(this.firearmsTransactionInfo)
	},
    watch: {
		// sectionsComplete(newVal) {
		// 	if (newVal == 1) {
		// 		this.$refs.serial_number[0].focus()
		// 	}
		// }
	},
    computed: {
		isDisposable() {
            let serialNumberFound = false
            for (let i = 0; i < this.serial_numbers.length; i++) {
                if (this.serial_numbers[i]['ffl_log_book_entry_id']) {
	                serialNumberFound = true
                    break;
                }
            }
			return serialNumberFound && (this.sectionsComplete > 2 || (this.sectionsComplete > 1 && this.contact.ffl_number))
		},
	    sectionsComplete() {
		    if (this.entry.disposal_date && this.notEmpty(this.contact,['address_1','city','state','zip_code']) && this.serial_numbers.length > 0 && (this.entry.nics_number || this.entry.repair_number || this.entry.notes) && this.transactionInfoComplete) {
			    return 3
		    } else if (this.entry.disposal_date && this.notEmpty(this.contact,['address_1','city','state','zip_code']) && this.serial_numbers.length > 0 && this.transactionInfoComplete) {
			    return 2
			} else if (this.entry.disposal_date && this.notEmpty(this.contact,['address_1','city','state','zip_code']) && this.transactionInfoComplete) {
				return 1
			} else {
			    return 0
			}
		},
		transactionInfoComplete() {
			if (this.fflTransactionInfoRequired && this.entry.transaction_info_required) {
				if (this.entry.date_of_birth && this.entry.employee_name && this.entry.disposition_type) {
					if (this.entry.disposition_type == 'Other' && !this.entry.disposition_type_other) {
						return false
					} else if (this.entry.disposition_type == 'transfer_ffl' && !this.entry.disposition_ffl_number) {
						return false
					} else {
						// all serial numbers must have a finish
						for (let i = 0; i < this.serial_numbers.length; i++) {
							if (this.serial_numbers[i]['gun_type'] && this.gunTypesRequired.includes(this.serial_numbers[i]['gun_type'])) {
								if (!this.serial_numbers[i]['finish']) {
									return false
								} else if (this.serial_numbers[i]['finish'] == 'two_toned' && (!this.serial_numbers[i].finish_two_toned_1 || !this.serial_numbers[i].finish_two_toned_2)) {
									return false
								} else if (this.serial_numbers[i]['finish'] == 'cerakote' && !this.serial_numbers[i].finish_cerakote) {
									return false
								} else if (this.serial_numbers[i]['finish'] == 'other' && !this.serial_numbers[i].finish_other) {
									return false
								}
							}
						}
					}
					return true
				} else {
					return false
				}
			} else {
				return true
			}
		},
    	filteredLogBookForms() {
    		var filteredLogBookForms;
    		if (this.search_4473 && this.logBookForms.length != 0) {
    			filteredLogBookForms = this.logBookForms.filter(logBookForm => {
    				if (logBookForm.version > 1) {
						return ((logBookForm.ffl_log_book_form_id == parseInt(this.search_4473) > -1) ||
    					(logBookForm.form_data.section_b.first_name.toLowerCase().indexOf(this.search_4473.toLowerCase()) > -1) ||
    					(logBookForm.form_data.section_b.last_name.toLowerCase().indexOf(this.search_4473.toLowerCase()) > -1) ||
    					(logBookForm.form_data.section_b.address_1.toLowerCase().indexOf(this.search_4473.toLowerCase()) > -1) ||
    					(logBookForm.form_data.section_b.city.toLowerCase().indexOf(this.search_4473.toLowerCase()) > -1) ||
    					(logBookForm.form_data.section_b.state.toLowerCase().indexOf(this.search_4473.toLowerCase()) > -1) ||
    					(logBookForm.form_data.section_b.zip_code.indexOf(this.search_4473) > -1) ||
    					(logBookForm.nics_number.indexOf(this.search_4473) > -1))
					} else {
						return false
					}
    			})
    			return filteredLogBookForms
    		} else {
    			return this.logBookForms
    		}
    	}
	},
	methods: {
		getRequiredGunTypes() {
			this.apiCall({ destination: 'get_list_gun_types' }).then(obj => {
			if (obj.status == 'success') {
				this.gun_types = obj.gun_types
                if (obj.required_gun_types) {
                    this.gunTypesRequired = obj.required_gun_types
                }
			}
			}).catch(err => {
				console.log(err)
			})
		},
		toggleNICSNotRequired() {
			this.nics_not_required = !this.nics_not_required
			if (this.nics_not_required) {
				this.entry.notes = 'NICS not required'
			} else {
				this.entry.notes = ''
			}
		},
		notEmpty(object, elements) {
			for (var i in elements) {
				if (typeof object[elements[i]] == 'undefined' || object[elements[i]] == null || object[elements[i]] == "") {
					return false
				}
			}
			return true
		},
		switchDisposalSearch() {
			this.entry = {
	    		ffl_log_book_entry_id: '',
	    		disposal_date: '',
	    		disposal_contact_id: '',
	    		nics_number: '',
	    		form_number: '',
	    		repair_number: '',
				notes: '',
				product_id: '',
				transaction_info_required: true,
				disposition_type: '',
				disposition_type_ad: '',
				disposition_type_other: '',
				date_of_birth: '',
				occupation: '',
				gender: '',
				ethnicity: '',
				race: '',
				employee_name: this.employeeName
			}
            this.nics_not_required = ''
            this.reloadDateInput = Math.random()
    		this.serial_numbers = []
			this.contact = {
				first_name: null,
                middle_name: null,
				last_name: null,
                suffix: null,
				company_name: null,
				address_1: null,
				address_2: null,
				city: null,
				state: null,
				zip_code: null,
				ffl_number: null,
				notes: [{ note: '', priority: '' }]
			}
			this.disposeFrom4473 = !this.disposeFrom4473
			this.ffl_log_book_form_id = ''
		},
		searchSerialNumbers() {
			let excludeFromSearch = []
			for (var i = 0; i < this.serial_numbers.length; i++) {
				if (this.serial_numbers[i].serial_number != this.serialNumberSearch) {
					excludeFromSearch.push(this.serial_numbers[i])
				}
			}
			this.apiCall({ destination: 'get_list_serial_numbers', data: { on_hand: 1, search_term: this.serialNumberSearch, exclude: excludeFromSearch, ffl_transaction_info: this.fflTransactionInfoRequired }}).then(obj => {
				this.client_id = obj.client_id
				if (obj.status == 'error') {
					this.serialNumberSearchMessage = obj.message
				} else if (obj.serial_numbers.length > 1) {
					this.serialNumberSearchResults = obj.serial_numbers
					if (obj.form_number && !this.form.form_number) {
						this.form.form_number = obj.form_number
					}
				} else if (obj.serial_numbers.length == 1) {
					this.assignSerialNumber(obj.serial_numbers[0])
					this.serialNumberSearchMessage = ''
					this.serialNumberSearchResults = []
					this.serialNumberSearch = ''
				} else {
					this.serialNumberSearchMessage = 'No matching serial numbers found'
				}
				if (obj.form_number && !this.form.form_number) {
					this.form.form_number = obj.form_number
				}
			})
		},
		assignSerialNumber(serialNumber) {
			// this.serial_numbers.push(serialNumber)
			// add serialNumber to the BEGINNING of the array so it shows up first in the list of serial numbers for the disposition
			this.serial_numbers.unshift(serialNumber)
			this.serialNumberSearchMessage = ''
			this.serialNumberSearchResults = []
			this.serialNumberSearch = ''
		},
		cancelSerialNumberSearchResults() {
			this.serialNumberSearchResults = []
			this.serialNumberSearch = ''
			this.serialNumberSearchMessage = ''
		},
		removeSerialInput(index) {
			this.serial_numbers.splice(index, 1)
		},
		getContactsRecentActivity() {
			if (this.disposals) {
				const contact_ids = this.disposals.map(contact => contact.contact_id);
				this.message = "";
				this.saving = true;
				this.apiCall({
				destination: "get_list_contacts_recent_logbook_activity",
				data: { contact_ids: contact_ids },
				}).then((obj) => {
				if (obj.status == "error") {
					this.message = obj.message;
				} else if (obj.list.length > 0) {
					this.recentActivities = obj.list;
					const recentActivitiesMap = new Map(this.recentActivities.map(activity => [activity.contact_id, activity.activity_date]));
					for (const contact of this.disposals) {
						const recentActivity = recentActivitiesMap.get(contact.contact_id);
						if (recentActivity) {
							const today = this.$moment().startOf('day');
							const activityDate = this.$moment(recentActivity).startOf('day');
							const activityDaysAgo = today.diff(activityDate, 'days');
							if (activityDaysAgo > 10) {
								continue;
							}
							this.$set(contact, 'activityDaysAgo', activityDaysAgo);
							this.$set(contact, 'activityDate', activityDate);
						}
					}
				}
				this.saving = false;
				}).catch((err) => {
					console.log(err);
					this.saving = false;
					this.messageStatus = 'error'
					this.message = 'Request failed. Please check your connection and try again.'
				});
			}
		},
		searchDisposals() {
            this.searchingDisposals = true
			this.disposals = null
			this.disposalSearchMessage = null
			this.apiCall({ destination: 'get_list_disposals', data: { source: 'LOGBOOKS', search_term: this.search_disposals, search_all_contacts: true, transaction_info: this.fflTransactionInfoRequired }}).then(obj => {
                this.searchingDisposals = false
				this.client_id = obj.client_id
				if (obj.status == 'error') {
					this.disposalSearchMessage = obj.message
				} else if (obj.disposals.length > 1) {
					this.disposals = obj.disposals
					this.getContactsRecentActivity()
				} else if (obj.disposals.length == 1) {
					this.assignDisposal(obj.disposals[0])
				} else {
					this.disposalSearchMessage = 'nothing found'
				}
			})
		},
		newDisposedTo() {
			this.disposals = []
			this.disposalSearchMessage = null
			this.resetContact()
			this.contact.client_id = this.client_id
			this.editingDisposal = true
		},
		getDisposalById(disposalId) {
			this.disposals = null
			this.disposalSearchMessage = null
			this.apiCall({ destination: 'get_list_disposals', data: { contact_id: disposalId }}).then(obj => {
				this.client_id = obj.client_id
				if (obj.status == 'error') {
					this.disposalSearchMessage = obj.message
				} else if (obj.disposals.length == 1) {
					this.assignDisposal(obj.disposals[0])
				} else {
					this.disposalSearchMessage = 'nothing found'
				}
			})
		},
		setList(list) {
			if (list.length > 1) {
				this.disposals = list
			} else if (list.length == 1) {
				this.apiCall({ destination: 'get_disposal_from_ffl_search', data: list[0] }).then(obj => {
					if (obj.status == 'success') {
						this.assignDisposal(obj.disposal_detail)
					} else {
						this.disposalSearchMessage = obj.message
					}
				}).catch(err => {
					console.log(err)
				})
			} else {
				this.disposalSearchMessage = 'No matching FFL found.'
			}
		},
		assignDisposal(disposal, isLogBookForm) {
			this.disposals = []
			this.search_disposals = null
			this.editingDisposal = false
			if (isLogBookForm) {
                // disposing from a 4473 with serial number(s)
				this.logBookFormId = disposal.ffl_log_book_form_id // will be used by goToForm
                if (disposal.version > 1) {
			        disposal.full_name = this.$fullName(disposal.form_data.section_b)
					this.populateDisposal(disposal)
    				// confirm there is at least one serial number recorded with this form
    				if (disposal.form_data.section_a && disposal.form_data.section_a.firearms_list) {
    					// TODO: call get_list_serial_numbers to get sequence numbers and log book entry ids
    					let serialNumbers = disposal.form_data.section_a.firearms_list.map(firearm => firearm.serial_number)
                        let fflLogBookEntryIds = disposal.form_data.section_a.firearms_list.map(firearm => firearm.ffl_log_book_entry_id)
    					this.apiCall({ destination: 'get_list_serial_numbers', data: { on_hand: 1, search_term: serialNumbers, ffl_log_book_entry_id: fflLogBookEntryIds, ffl_log_book_form_id: disposal.ffl_log_book_form_id }}).then(obj => {
    						//this.serial_numbers = obj.serial_numbers
                            if (obj.serial_numbers.length > 0) {
                                this.serial_numbers = obj.serial_numbers
                            } else {
        					    this.modalFor = 'No disposable serial numbers'
        					    this.modalContent = 'Name: ' + this.$fullName(disposal.form_data.section_b) + '<br><br>There are no disposable serial numbers associated with this 4473.<br><br>This could be because they have already been disposed.'
            					this.showModal = true
                            }
    					})
    				}
                } else {
			        disposal.full_name = this.$fullName(disposal.form_data)
					this.populateDisposal(disposal)
    				// confirm there is at least one serial number recorded with this form
    				if (disposal.form_data.section_d && disposal.form_data.section_d.firearms_list) {
    					// TODO: call get_list_serial_numbers to get sequence numbers and log book entry ids
    					let serialNumbers = disposal.form_data.section_d.firearms_list.map(firearm => firearm.serial_number)
    					this.apiCall({ destination: 'get_list_serial_numbers', data: { on_hand: 1, search_term: serialNumbers }}).then(obj => {
    						//this.serial_numbers = obj.serial_numbers
                            if (obj.serial_numbers.length > 0) {
                                this.serial_numbers = obj.serial_numbers
                            } else {
                                this.modalFor = 'No Section A serial numbers'
                                this.modalContent = 'Name: ' + this.$fullName(disposal.form_data) + '<br><br>There are no disposable serial numbers saved in Section D of this 4473.<br><br>This could be because they have already been disposed.'
            					this.showModal = true
                            }
    					})
    				}
                }
			} else {
				disposal.full_name = this.$fullName(disposal)
				this.showLogBookFormList = false
				this.entry.date_of_birth = disposal.birthdate
				this.entry.occupation = disposal.occupation
				this.contact = disposal
			}
        },
        populateDisposal(disposal) {
			if (disposal.version > 1) {
				this.showLogBookFormList = false
                if (disposal.form_data.section_e.transfer_date) {
                    this.entry.disposal_date = disposal.form_data.section_e.transfer_date
                }
				this.contact = {
					contact_id: disposal.contact_id,
					first_name: disposal.form_data.section_b.first_name,
					middle_name: disposal.form_data.section_b.middle_name,
					last_name: disposal.form_data.section_b.last_name,
                    suffix: disposal.form_data.section_b.suffix,
					company_name: disposal.form_data.section_b.company_name,
					address_1: disposal.form_data.section_b.address_1,
					address_2: disposal.form_data.section_b.address_2,
					city: disposal.form_data.section_b.city,
					state: disposal.form_data.section_b.state,
					zip_code: disposal.form_data.section_b.zip_code,
					birthdate: disposal.form_data.section_b.birth_date
				}
				this.entry.city = disposal.form_data.section_b.city
				this.entry.state = disposal.form_data.section_b.state
				this.ffl_log_book_form_id = disposal.ffl_log_book_form_id
				this.entry.form_number = disposal.form_number

				this.entry.occupation = disposal.form_data.section_b.occupation
				this.entry.date_of_birth = disposal.form_data.section_b.birthdate

				// convert form values to log book entry values
				// "customer_race":{"l4":"","l2":"","l6":"","l1":true,"l5":""}
				if (disposal.form_data.section_b.customer_race.l4) {
					this.entry.race = 'native_american'
				} else if (disposal.form_data.section_b.customer_race.l1) {
					this.entry.race = 'asian'
				} else if (disposal.form_data.section_b.customer_race.l2) {
					this.entry.race = 'black'
				} else if (disposal.form_data.section_b.customer_race.l6) {
					this.entry.race = 'native_hawaiian'
				} else if (disposal.form_data.section_b.customer_race.l7) {
					this.entry.race = 'caucasian'
				}
				// "ethnicity":"nonhispanic"
				this.entry.ethnicity = disposal.form_data.section_b.ethnicity
				// "gender_code":"M"
				this.entry.gender = disposal.form_data.section_b.gender_code

				this.entry.notes = ''
                this.entry.nics_number = ''
                if (disposal.nics_number) {
                    this.entry.nics_number = disposal.nics_number
                } else if (disposal.form_data.section_c.nics_buyer_exempt_permit_state_type || disposal.form_data.section_c.nics_buyer_exempt_permit_number) {
                    if (disposal.form_data.section_c.nics_buyer_exempt_permit_state_type) {
                        this.entry.nics_number += disposal.form_data.section_c.nics_buyer_exempt_permit_state_type + ' '
                    }
                    if (disposal.form_data.section_c.nics_buyer_exempt_permit_number) {
                        this.entry.nics_number += disposal.form_data.section_c.nics_buyer_exempt_permit_number
                    }
                }
                if (disposal.form_data.section_c.nics_buyer_background_check || disposal.form_data.section_c.nics_buyer_exempt) {
        			this.nics_not_required = true
    				this.entry.notes += 'NICS not required '
                }
                if (disposal.form_data.section_final && disposal.form_data.section_final.transfer_date) {
				    this.entry.disposal_date = disposal.form_data.section_final.transfer_date
                }
                if (disposal.form_data.section_d.seller_notes) {
		            this.entry.notes += disposal.form_data.section_d.seller_notes
                }
			} else if (disposal.form_data.section_d) {
				this.showLogBookFormList = false
				this.contact = {
					contact_id: disposal.contact_id,
					first_name: disposal.form_data.first_name,
					middle_name: disposal.form_data.middle_name,
					last_name: disposal.form_data.last_name,
					suffix: disposal.form_data.suffix,
					company_name: disposal.form_data.company_name,
					address_1: disposal.form_data.address_1,
					address_2: disposal.form_data.address_2,
					city: disposal.form_data.city,
					state: disposal.form_data.state,
					zip_code: disposal.form_data.zip_code,
					birthdate: disposal.form_data.birth_date
				}
				this.ffl_log_book_form_id = disposal.ffl_log_book_form_id
				this.entry.form_number = disposal.form_number
				this.entry.nics_number = disposal.nics_number || disposal.form_data.section_b.nics_buyer_exempt_permit_number
				this.entry.notes = disposal.form_data.section_d.seller_notes
                if (disposal.form_data.section_final && disposal.form_data.section_final.transfer_date) {
				    this.entry.disposal_date = disposal.form_data.section_final.transfer_date
                }
			} else {
                if (disposal.version > 1) {
		    	    this.modalFor = 'Nothing saved in Section A',
				    this.modalContent = 'Name: ' + this.$fullName(disposal.section_b) + '<br><br>Nothing has been saved in Section A for this 4473.<br>Please complete the form before disposing.'
                } else {
		    	    this.modalFor = 'Nothing saved in Section D',
				    this.modalContent = 'Name: ' + this.$fullName(disposal) + '<br><br>Nothing has been saved in Section D for this 4473.<br>Please complete the form before disposing.'
                }
				this.showModal = true
			}
		},
		searchFormNumbers() {
			this.apiCall({ destination: 'get_list_4473_form_numbers', data: { search_term: this.entry.form_number }}).then(obj => {
				if (obj.status == 'error') {
					this.formNumberSearchMessage = obj.message
				} else {
					if (obj.form_numbers.length > 0) {
						this.form_numbers = obj.form_numbers
					} else {
						this.formNumberSearchMessage = 'No Transaction Serial Numbers found'
					}
				}
			})
		},
		assignFormNumber(formNumber) {
			this.entry.form_number = formNumber
			this.form_numbers = []
		},
		goToForm() {
			if (this.$route.query.form){
				this.$router.push('/logbooks/4473/' + this.$route.query.form)
			} else {
				this.$router.push('/logbooks/4473/' + this.selectedFormId)
			}
		},
		getListSerialNumbers() {
			this.serial_numbers = []
			this.apiCall({ destination: 'get_list_serial_numbers', data: { ffl_log_book_entry_id: this.id, ffl_transaction_info: this.fflTransactionInfoRequired }}).then(obj => {
				if (obj.status == 'error') {
					this.disposalSearchMessage = obj.message
				} else {
					this.serial_numbers = obj.serial_numbers
					this.client_id = obj.client_id
				}
			})
		},
		getListLogBookForms() {
			// if there is a query 'form' we're coming from 'Dispose This Form'
            if (this.$route.query.form) {
                this.getDisposeThisForm(this.$route.query.form)
				return
            }
            this.loading = true
            let postData = {
                disposable: 1, form_type: '4473', full_list: 1
            }
			this.apiCall({ destination: 'get_list_ffl_log_book_forms', data: postData }).then((obj) => {
				if (obj.status == 'success') {
					this.definition = obj.definition
					this.client_id = obj.client_id
                    this.logBookForms = obj.log_book_forms
				}
				this.loading = false
			}).catch((err) => {
				console.log(err)
				this.loading = false
			})
		},
		getDisposeThisForm(formId) {
			this.selectedFormId = formId
			if (this.loading) { return }
			this.loadingModal = true
			this.modalFor = 'Dispose This Form',
			this.modalContent = "Getting disposed to and serial number info for this form..."
			this.showModal = true
			this.apiCall({ destination: 'get_item_ffl_log_book_form_for_disposal', data: { ffl_log_book_form_id: formId } }).then((obj) => {
				this.loadingModal = false
				if (obj.log_book_form) {
					this.populateDisposal(obj.log_book_form)
				}
				this.modalStatus = obj.status
				if (obj.status == 'success') {
					if (obj.serial_numbers && obj.serial_numbers.length > 0) {
						this.serial_numbers = obj.serial_numbers
					}
					this.loadingModal = false
					this.modalFor = '',
					this.modalContent = ''
					this.showModal = false
				} else {
					this.modalContent = obj.message
				}
			}).catch((err) => {
				console.log(err)
				this.loadingModal = false
			})
		},
		saveDisposition() {
			if (!this.isDisposable || this.dispositionComplete || this.saving) {
				return false
			}
			this.saving = true
			this.message = 'Saving disposal...'
			this.messageStatus = ''
			// only post non-blank serial numbers
			let postSerialNumbers = []
			for (let i = 0; i < this.serial_numbers.length; i++) {
				if (this.serial_numbers[i]['serial_number'] && this.serial_numbers[i]['ffl_log_book_entry_id']) {
					postSerialNumbers.push(this.serial_numbers[i])
				}
			}
			if (postSerialNumbers.length < 1) {
				this.message = 'There are no serial numbers selected.'
				this.messageStatus = 'invalid'
				this.saving = false
				return false
			}
            let disposedByNote = 0
            if (this.nics_not_required || (!this.entry.nics_number && !this.entry.repair_number && this.entry.notes)) {
                disposedByNote = 1
            }
			this.apiCall({ destination: 'save_item_ffl_log_book_entry', data: { disposing: 1, entry: this.entry, contact: this.contact, serial_numbers: postSerialNumbers, disposed_by_note: disposedByNote, ffl_log_book_form_id: this.ffl_log_book_form_id } }).then(obj => {
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					if (this.fflTransactionInfoRequired && this.entry.transaction_info_required) {
						this.message = 'Saving additional transaction info...'
						this.apiCall({ destination: 'save_item_ffl_transaction_record', data: { is_disposal: true, entry: this.entry, contact: this.contact, serial_numbers: postSerialNumbers } }).then(obj => {
							this.saving = false
							this.messageStatus = obj.status
							if (obj.status == 'success') {
								this.saving = false
								this.message = "Success! " + obj.message
								this.messageTimeout = 2000
								this.dispositionComplete = true
							} else {
								this.message = "Error: " + obj.message
								this.messageTimeout = 0
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.saving = false
						this.message = "Success! " + obj.message
						this.messageTimeout = 2000
						this.dispositionComplete = true
					}
                    if (obj.updated_ffl_log_book_entry_id) {
                        this.entry.ffl_log_book_entry_id = obj.updated_ffl_log_book_entry_id
                    }
				} else {
					this.saving = false
					this.message = "Error: " + obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		clearData(reset) {
    		this.entry = {
	    		ffl_log_book_entry_id: null,
	    		disposal_date: '',
	    		disposal_contact_id: null,
	    		nics_number: null,
	    		form_number: null,
	    		repair_number: null,
				notes: null,
				transaction_info_required: true,
				disposition_type: '',
				disposition_type_ad: '',
				disposition_type_other: '',
				date_of_birth: '',
				occupation: '',
				gender: '',
				ethnicity: '',
				race: '',
				employee_name: this.employeeName
    		}
            this.nics_not_required = ''
            this.reloadDateInput = Math.random()
    		this.serial_numbers = []
			this.disposals = []
			this.ffl_log_book_form_id = ''
			this.searchingSerialNumberIndex = 0
			this.serialNumberSearchResults = []
			this.serialNumberSearchMessage = ''
            this.dispositionComplete = false
			this.showLogBookFormList = false
			this.selectedFormId = ''
			this.resetContact()
			if (reset) {
				this.getListLogBookForms()
			}
		},
		resetContact() {
			this.contact = {
				client_id: null,
				contact_id: null,
				first_name: null,
				last_name: null,
				company_name: null,
				address_1: null,
				address_2: null,
				city: null,
				state: null,
				zip_code: null,
				ffl_number: null,
				notes: [{ note: '', priority: '' }]
			}
		},
		doPrint() {
            if (this.loadingLogBookEntry) {
                return
            }
        	this.loadingLogBookEntry = true
			this.apiCall({ destination: 'get_item_ffl_log_book_entry', data: { ffl_log_book_entry_id: this.entry.ffl_log_book_entry_id, print: true } }).then(obj => {
        		this.loadingLogBookEntry = false
				if (obj.pdf_url) {
                	window.open(obj.pdf_url)
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
        		this.loading = false
			})
		},
		formatRelativeDate(date) {
			const target = this.$moment(date).startOf('day');
			const today = this.$moment().startOf('day');
			const daysAgo = today.diff(target, 'days');

			if (daysAgo === 0) return 'from today';
			if (daysAgo === 1) return 'from yesterday';
			return `within the last ${daysAgo} days`;
    	}
	}
}
</script>

<style lang="scss" scoped>
</style>
